
import { useTranslation } from 'react-i18next';
import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import ProjectGallery from '@/components/feature/ProjectGallery';
import { documentaryProjects } from '@/mocks/projects';

export default function DocPage() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main className="pt-20">
        <div className="container mx-auto px-6 py-16">
          <div className="text-center mb-16">
            <h1 className="text-5xl md:text-6xl font-light tracking-wider text-gray-900 mb-8">
              DOCUMENTARY
            </h1>
          </div>
          
          <ProjectGallery projects={documentaryProjects} />
        </div>
      </main>
      <Footer />
    </div>
  );
}
